import PropTypes from "prop-types";

const Decoration = ({ height, width, className, x, y, fill }) => {
  const viewBox = `0 0 ${width} ${height}`;
  const translate = `translate(${x} ${y})`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className={className}
      transform={x && y && translate}
      aria-hidden
    >
      <rect width={width} height={height} fill={fill} />
    </svg>
  );
};

Decoration.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  className: PropTypes.string,
  x: PropTypes.string,
  y: PropTypes.string,
  fill: PropTypes.string,
};

Decoration.defaultProps = {
  x: "",
  y: "",
  fill: "white",
};

export default Decoration;
